'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = objectById;
function objectById(arr, id) {
    var attrName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

    if (arr == null) {
        return null;
    }
    var len = arr.length;
    for (var a = 0; a < len; a++) {
        if (arr[a][attrName] == id) {
            return arr[a];
        }
    }
    return null;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvb2JqZWN0QnlJZC5qc3giXSwibmFtZXMiOlsib2JqZWN0QnlJZCIsImFyciIsImlkIiwiYXR0ck5hbWUiLCJsZW4iLCJsZW5ndGgiLCJhIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLFU7QUFBVCxTQUFTQSxVQUFULENBQW9CQyxHQUFwQixFQUF5QkMsRUFBekIsRUFBOEM7QUFBQSxRQUFqQkMsUUFBaUIsdUVBQU4sSUFBTTs7QUFDekQsUUFBSUYsT0FBTyxJQUFYLEVBQWlCO0FBQ2IsZUFBTyxJQUFQO0FBQ0g7QUFDRCxRQUFNRyxNQUFNSCxJQUFJSSxNQUFoQjtBQUNBLFNBQUssSUFBSUMsSUFBSSxDQUFiLEVBQWdCQSxJQUFJRixHQUFwQixFQUF5QkUsR0FBekIsRUFBOEI7QUFDMUIsWUFBSUwsSUFBSUssQ0FBSixFQUFPSCxRQUFQLEtBQW9CRCxFQUF4QixFQUE0QjtBQUN4QixtQkFBT0QsSUFBSUssQ0FBSixDQUFQO0FBQ0g7QUFDSjtBQUNELFdBQU8sSUFBUDtBQUNIIiwiZmlsZSI6Im9iamVjdEJ5SWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBvYmplY3RCeUlkKGFyciwgaWQsIGF0dHJOYW1lID0gJ2lkJykge1xuICAgIGlmIChhcnIgPT0gbnVsbCkge1xuICAgICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG4gICAgY29uc3QgbGVuID0gYXJyLmxlbmd0aDtcbiAgICBmb3IgKGxldCBhID0gMDsgYSA8IGxlbjsgYSsrKSB7XG4gICAgICAgIGlmIChhcnJbYV1bYXR0ck5hbWVdID09IGlkKSB7XG4gICAgICAgICAgICByZXR1cm4gYXJyW2FdO1xuICAgICAgICB9XG4gICAgfVxuICAgIHJldHVybiBudWxsO1xufVxuIl19